import { Col, Row } from 'components-antd';
import classNames from 'classnames';

import { DocumentsPopover } from '../DocumentsPopover';
import { SmartFormIcons } from 'components';
import { dynamicManager } from 'pages/FormProcess/DynamicForm/DynamicManager';
import { getDynamicFormSelector } from 'store/selectors/requestFormProcess';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { resetPostFormUpdateEffect, updateSignatoriesEffect } from 'store/effects/formProcess';
import { createReplacePayload } from 'pages/FormProcess/components/DynamicPostForm/helper';
import { getEmailToSignerMap } from '../../helper';

import styles from './styles.module.scss';
import { FormPill } from 'pages/FormProcess/components';
export const SignFormHeader = ({ isSendDocument, pdfDocRefs, documentIds, isWebView }) => {
  const {
    postFormUpdates,
    dynamicFormDocuments,
    allowRegress,
    meta: { documentName, address, clientName },
  } = useSelector(getDynamicFormSelector);

  const [activeScrolledDocumentId, setScrolledDocumentId] = useState(
    dynamicFormDocuments?.[0].Id || -1,
  );

  const dispatch = useDispatch();

  useEffect(() => {
    const handleScroll = () => {
      let currentDocId = -1;
      Object.values(pdfDocRefs.current).forEach((docItem: any) => {
        const rect = docItem?.getBoundingClientRect();
        if (rect && rect.top <= 90 && rect.bottom >= 90) {
          const documentIndex = docItem.id.split('pdf-doc-')[1];

          currentDocId = dynamicFormDocuments?.[documentIndex]?.Id || -1;
        }
      });

      setScrolledDocumentId(currentDocId);
    };

    window.addEventListener('scroll', handleScroll, true);
    return () => {
      window.removeEventListener('scroll', handleScroll, true);
    };
  }, []);

  const manageSendDocumentClose = () => {
    const signatories = postFormUpdates?.signatories || [];
    const isSequential = postFormUpdates?.isSequential || false;
    const replacedSignatories = signatories?.filter((item) => item.isReplaced) || [];

    if (!replacedSignatories.length) {
      dynamicManager.updatePostFormSignatureSequence({
        isSequential,
        signatories,
        ...documentIds,
      });
    } else {
      dispatch(
        updateSignatoriesEffect(
          {
            formProcessPublicId: dynamicManager.getFormProcessPublicId(),
            Signatories: createReplacePayload(replacedSignatories, isSequential),
          },
          (err, response) => {
            if (!err) {
              const { signatoriesAdded } = response.data.value;

              const emailToSignerMap = getEmailToSignerMap(signatoriesAdded);

              for (const signer of signatories) {
                const matched = emailToSignerMap[signer.Email];
                if (matched) {
                  signer.signatoryId = matched.SignatureRequestId;
                }
              }

              dynamicManager.updatePostFormSignatureSequence({
                isSequential,
                signatories,
                ...documentIds,
              });
            }
          },
        ),
      );
    }
  };

  const onCloseForm = () => {
    const { sequenceModified, hasModifiedInfo } = postFormUpdates || {
      sequenceModified: false,
      hasModifiedInfo: false,
    };

    if (isSendDocument && (sequenceModified || hasModifiedInfo)) {
      manageSendDocumentClose();
    }
    dynamicManager.handleFormExit();
  };

  const handleGoBack = () => {
    if (isSendDocument) {
      dispatch(resetPostFormUpdateEffect());
    }

    dynamicManager.gotBackToPreviousScreen();
  };

  return (
    <div className={styles.signFormHeader}>
      <Row
        className={classNames(styles.signHeaderContent, {
          [styles.showBorder]: !isSendDocument,
          [styles.webViewSignHeaderContent]: isWebView,
        })}
      >
        <Col>
          {allowRegress ? (
            <div className={classNames(styles.navigationIcons, styles.editNavigation)}>
              <div className={styles.navigationButton} onClick={handleGoBack}>
                {allowRegress && <SmartFormIcons variant={isSendDocument ? 'back' : 'pencil'} />}
              </div>
            </div>
          ) : (
            <div className={styles.emptyNavigation} />
          )}
        </Col>

        {!isSendDocument ? (
          <Col className={styles.documentPopoverColumn}>
            <DocumentsPopover
              allDocuments={dynamicFormDocuments}
              scrolledDocumentId={activeScrolledDocumentId}
            />
          </Col>
        ) : (
          <div className={styles.sendDocumentPill}>
            <FormPill
              clientAddress={address}
              clientName={clientName}
              pdfName={documentName}
              disableEditName
              pdfInfoClass={styles.sendDocumentPDFInfo}
              pdfNameClass={styles.sendDocumentPDFName}
            />
          </div>
        )}

        <Col>
          <div className={classNames(styles.navigationIcons, styles.closeNavigation)}>
            <div className={styles.navigationButton} onClick={onCloseForm}>
              <SmartFormIcons variant="cancel" />
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};
